import { useMemo } from 'react';

export function useBaseFilters(config) {
  return useMemo(() => {
    let base = {};

    if (config.officeIds) base.clientOfficeId = config.officeIds;
    if (config.countryCode) base.countryCode = config.countryCode;
    if (config.sourceId) base.sourceId = config.sourceId;
    if (config.sources) base.sources = config.sources;

    base.limit = 10000;
    base.format = `map`;

    return base;
  }, []);
}
